var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronSmallDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4 4 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.293 12.293L16 17.586L10.707 12.293C10.5184 12.1109 10.2658 12.0101 10.0036 12.0123C9.74138 12.0146 9.49057 12.1198 9.30516 12.3052C9.11975 12.4906 9.01458 12.7414 9.01231 13.0036C9.01003 13.2658 9.11082 13.5184 9.29298 13.707L15.293 19.707C15.4805 19.8945 15.7348 19.9998 16 19.9998C16.2651 19.9998 16.5195 19.8945 16.707 19.707L22.707 13.707C22.8891 13.5184 22.9899 13.2658 22.9877 13.0036C22.9854 12.7414 22.8802 12.4906 22.6948 12.3052C22.5094 12.1198 22.2586 12.0146 21.9964 12.0123C21.7342 12.0101 21.4816 12.1109 21.293 12.293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSmallDown);
export default __webpack_public_path__ + "static/media/chevron-small-down.f336da7016e96c688be096ed878c34ee.svg";
export { ForwardRef as ReactComponent };